// Demo admin route used to smoke-test platform AppShell + Navigation.
// Real admin content lands in F7 (Users CRUD vertical). The `staticData`
// declaration carries platform `RouteMeta` — TanStack's slot for arbitrary
// app-defined route data — which is what the platform's <Navigation/>
// reads to auto-derive the menu.

import { TablePage } from '@podium/platform/layouts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/dashboard')({
  component: AdminDashboard,
  staticData: {
    nav: { label: 'Dashboard', order: 10, group: 'Admin' },
    breadcrumb: 'Dashboard',
  },
})

function AdminDashboard() {
  return (
    <TablePage title="Admin dashboard" description="Smoke test for AppShell + Navigation.">
      <div className="rounded border border-dashed p-8 text-center text-sm text-muted-foreground">
        Real admin content lands in F7 (Users CRUD vertical).
      </div>
    </TablePage>
  )
}
